import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Input, Required, Label } from '../Form/Form';
import AuthApiService from '../../services/auth-api-service';
import Button from '../Button/Button';
import './RegistrationForm.css';

class RegistrationForm extends Component {
  static defaultProps = {
    onRegistrationSuccess: () => {}
  };

  state = { error: null };

  firstInput = React.createRef();

  handleSubmit = ev => {
    ev.preventDefault();
    const { name, username, password } = ev.target;
    AuthApiService.postUser({
      name: name.value,
      username: username.value,
      password: password.value
    })
      .then(user => {
        name.value = '';
        username.value = '';
        password.value = '';
        this.props.onRegistrationSuccess();
      })
      .catch(res => {
        this.setState({ error: res.error });
      });
  };

  componentDidMount() {
    this.firstInput.current.focus();
  }

  render() {
    const { error } = this.state;
    return (
      <form className="RegistrationForm" onSubmit={this.handleSubmit}>
        <fieldset>
          <Label htmlFor="registration-name-input">
            Enter your name
            <Required />
          </Label>
          <Input
            ref={this.firstInput}
            id="registration-name-input"
            name="name"
            aria-label="Name"
            aria-required="true"
            required
          />
        </fieldset>
        <fieldset>
          <Label htmlFor="registration-username-input">
            Choose a username
            <Required />
          </Label>
          <Input
            id="registration-username-input"
            name="username"
            aria-label="Username"
            aria-required="true"
            required
          />
        </fieldset>
        <fieldset>
          <Label htmlFor="registration-password-input">
            Choose a password
            <Required />
          </Label>
          <Input
            id="registration-password-input"
            aria-label="Password"
            aria-required="true"
            name="password"
            type="password"
            required
          />
        </fieldset>
        <div role="alert">{error && <p>{error}</p>}</div>
        <footer className="registrationFooter">
          <Button type="submit">Sign up</Button>{' '}
          <Link to="/login">Already have an account?</Link>
        </footer>
      </form>
    );
  }
}

export default RegistrationForm;
